import { createReducer, on } from "@ngrx/store";
import { ChardiState } from "./chardi.models";
import * as chardiActions from "../chardi/chardi.actions";
import { ChardiPendingOp } from "../../model/chardi.model";

export const initialChardiState: ChardiState = {
    chardiOverview: null,
    chardiConfiguration: null,
    loading: false,
    error: null,
};

export const chardiReducer = createReducer(
    initialChardiState,
    on(chardiActions.loadInitData, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.loadInitDataSuccessFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.loadInitDataSuccess, (state, { chardiOverview, chardiConfiguration }) => ({
        ...state,
        chardiOverview: {
            ...chardiOverview,
            pendingOp: chardiOverview.pendingOp,
        },
        chardiConfiguration: {
            ...chardiConfiguration
        },
        loading: false
    })),
    on(chardiActions.loadChardiConfiguration, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.loadChardiConfigurationFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.loadChardiConfigurationSuccess, (state, { chardiConfiguration }) => ({
        ...state,
        loading: false,
        chardiConfiguration: {
            ...chardiConfiguration
        }
    })),
    on(chardiActions.loadChardiOverview, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.loadChardiOverviewFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.loadChardiOverviewSuccess, (state, { chardiOverview }) => ({
        ...state,
        loading: false,
        chardiOverview: {
            ...chardiOverview
        }
    })),
    on(chardiActions.saveChardiConfiguration, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.saveChardiConfigurationFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.saveChardiConfigurationSuccess, (state, { response }) => ({
        ...state,
        loading: false,
        chardiConfiguration: {
            ...response
        }
    })),
    on(chardiActions.addToQueue, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.addToQueueSuccess, (state) => ({
        ...state,
        loading: false,
        chardiOverview: {
            ...state.chardiOverview!,
            pendingOp: ChardiPendingOp.ADD_TO_QUEUE
        }
    })),
    on(chardiActions.addToQueueFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.removeFromQueue, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.removeFromQueueSuccess, (state) => ({
        ...state,
        loading: false,
        chardiOverview: {
            ...state.chardiOverview!,
            pendingOp: ChardiPendingOp.REMOVE_FROM_QUEUE
        }
    })),
    on(chardiActions.removeFromQueueFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.stopTransaction, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.stopTransactionSuccess, (state) => ({
        ...state,
        loading: false
    })),
    on(chardiActions.stopTransactionFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),

    on(chardiActions.requestQueueReorder, (state) => ({
        ...state,
        loading: true
    })),
    on(chardiActions.requestQueueReorderSuccess, (state) => ({
        ...state,
        loading: false,
        chardiOverview: {
            ...state.chardiOverview!,
            pendingOp: ChardiPendingOp.REORDER
        }
    })),
    on(chardiActions.requestQueueReorderFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    })),
    on(chardiActions.updateMeterValue, (state, { meterValueChange }) => ({
        ...state,
        chardiOverview: {
            ...state.chardiOverview!,
            modules: [...(state.chardiOverview?.modules ?? [])],
            orderQueue: state.chardiOverview?.orderQueue.map(x => x.id == meterValueChange.parkingSpotId ? { ...x, soc: meterValueChange.soC } : x) ?? []
        }
    })),
    on(chardiActions.updateDisplayNames, (state) => ({
        ...state,
        loading: true
    })),
   on(chardiActions.updateDisplayNamesSuccess, (state, { request }) => {
        if (!state.chardiOverview) return { ...state, loading: false };

        const updates = new Map(
            (request.items ?? [])
            .filter(i => i.id != null)
            .map(i => [i.id!, i.displayName] as const),
        );

        return {
            ...state,
            loading: false,
            chardiOverview: {
                ...state.chardiOverview,
                modules: state.chardiOverview.modules.map(m =>
                    updates.has(m.id!) ? { ...m, displayName: updates.get(m.id!) } : m,
                ),
                orderQueue: state.chardiOverview.orderQueue.map(m =>
                    updates.has(m.id!) ? { ...m, displayName: updates.get(m.id!) } : m,
                )
            },
        };
    }),
    on(chardiActions.updateDisplayNamesFailure, (state, {error}) => ({
         ...state,
        loading: false,
        error: error.errorMessage ?? 'ERROR'
    }))
)
